import React, { useRef } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronRight } from "@fortawesome/free-solid-svg-icons";
import { usePointerState } from "../../hooks/usePointerState";

import styles from "./Row.module.css";
import clsx from "clsx";
import { useRoot } from "../../contexts/Root";

interface Props {
  icon?: React.ReactNode;
  onClick: () => void;
  label: string;
  hasArrow?: boolean | undefined;
  selected?: boolean;
  weakSelection?: boolean;
}

export const Row = ({
  icon,
  onClick,
  label,
  hasArrow = false,
  selected = false,
  weakSelection = false,
}: Props): JSX.Element => {
  const ref = useRef<HTMLButtonElement>(null);

  const {
    theme: {
      emphasis,
      primaryBackground,
      fadedEmphasis,
      foreground,
      seekBarBackground,
    },
  } = useRoot();

  const { isInside } = usePointerState(ref);

  const style = {
    background:
      (weakSelection && selected && fadedEmphasis) ||
      (selected && emphasis) ||
      (isInside && seekBarBackground) ||
      primaryBackground,
    color: foreground,
  };

  const containerClass = clsx(
    styles.container,
    selected && !weakSelection && styles.containerSelected,
    selected && weakSelection && styles.containerWeakSelected
  );

  return (
    <button
      ref={ref}
      role="button"
      tabIndex={0}
      className={containerClass}
      style={style}
      onClick={onClick}
    >
      {icon !== undefined && icon}
      <div className={styles.label}>{label}</div>
      {hasArrow && (
        <div className={styles.arrow}>
          <FontAwesomeIcon icon={faChevronRight} />
        </div>
      )}
    </button>
  );
};
